import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'

import { SelectBox } from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'
import type { PublicationBookingModel } from '@models/types'

type MapPublicationBookingsParams = {
  publicationBookings: PublicationBookingModel[],
}

const mapPublicationBookings = (params: MapPublicationBookingsParams) => {
  const { publicationBookings } = params

  const totalBookingCount = publicationBookings.length

  return publicationBookings.map((publicationBooking, index) => {
    const {
      booking_confirmation_id,
      id,
      publication_id,
      publication_edition_id,
    } = publicationBooking

    return {
      customIcon: <FontAwesomeIcon icon={faCircle} style={{ color: '#02b7e2', marginRight: 8 }} />,
      key: id,
      publication_edition_id,
      publication_id,
      title: `Page ${index + 1}/${totalBookingCount}${booking_confirmation_id ? ` - ${booking_confirmation_id}` : ''}`,
    }
  })
}

interface PageSelectorProps {
  callbacks: {
    selectPublicationBookingId: (params: HandleCallbackActionParams) => void,
  },
  publicationBookings: PublicationBookingModel[],
  selectedPublicationBookingId?: number,
}

const PageSelector = (props: PageSelectorProps) => {
  const {
    callbacks: {
      selectPublicationBookingId,
    },
    publicationBookings,
    selectedPublicationBookingId,
  } = props

  if (!publicationBookings.length){
    return null
  }

  return (
    <SelectBox
      callbacks={{
        // @ts-expect-error TS7006
        selectItem: item => selectPublicationBookingId({
          entityParams: {
            id: item.key,
            publication_edition_id: item.publication_edition_id,
            publication_id: item.publication_id,
          },
        }),
      }}
      items={mapPublicationBookings({
        publicationBookings,
      })}
      selectedItemKey={selectedPublicationBookingId}
      style={{ minWidth: 200 }}
    />
  )
}

export default PageSelector
